module.exports = __webpack_public_path__ + "img/ClickForSound_10.2142077a.png";